
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/muses/bts",
      function () {
        return require("private-next-pages/muses/bts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/muses/bts"])
      });
    }
  